"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const HourlyForecastLinear_1 = __importDefault(require("../../../../common/components/Weather/HourlyForecastLinear"));
const DayForecastLinear_1 = __importDefault(require("../../../../common/components/Weather/DayForecastLinear"));
const helpers_1 = require("../../../../common/helpers/helpers");
const weatherHelpers_1 = require("../../../../common/helpers/weatherHelpers");
const WeatherPageContainer = styled_components_1.default.div `
  animation-duration: ${(props) => props.fadeInContentTime * 1}s;

  height: 100%;
  padding: 12vmin 5vmin 5vmin 5vmin;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (orientation: portrait) {
    padding: 7vmin;
    justify-content: initial;
    gap: 6vh;
  }

  &.sunny {
    background: linear-gradient(330deg, #00416a, #d4f2ff);
  }

  &.rain {
    background: linear-gradient(to bottom right, rgba(174, 189, 194, 1), rgba(81, 90, 95, 1));
  }

  &.snow {
    background: linear-gradient(to bottom right, rgba(173, 192, 214, 1), rgba(173, 192, 214, 1));
  }

  &.night {
    background: linear-gradient(to bottom right, rgba(49, 83, 121, 1), rgba(0, 0, 0, 1));
  }

  .day-weather {
    &.hidden {
      display: none;
    }

    animation-duration: ${(props) => props.slideInTime * 1}s;

    display: flex;
    justify-content: space-between;

    @media (orientation: portrait) {
      flex-direction: column;
      gap: 3vh;
    }
  }

  .lower-content {
    .day-1,
    .day-4.exit-1 {
      animation-delay: 0s;
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }

    .day-2,
    .day-3.exit-2 {
      animation-delay: ${(props) => props.slideInTime * 0.15}s;
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }

    .day-3,
    .day-2.exit-3 {
      animation-delay: ${(props) => props.slideInTime * 0.3}s;
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }

    .day-4,
    .day-1.exit-4 {
      animation-delay: ${(props) => props.slideInTime * 0.45}s;
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }

    &.hidden {
      display: none;
    }
  }

  .now,
  .weather-location {
    color: #fff;
  }

  .now,
  .summary {
    font-size: 3vmin;
    font-weight: 400;

    @media (orientation: portrait) {
      font-size: 3vmin;
    }
  }

  .summary {
    font-size: 3.5vmin;
  }

  .temperature {
    font-size: 12vmin;
    font-weight: 500;
    letter-spacing: -0.97px;
    margin-right: 1.5vmin;
    margin-top: 3vmin;
    line-height: 11vmin;

    @media (orientation: portrait) {
      font-size: 9vmin;
      line-height: 9vmin;
    }
  }

  .weather-location {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .time-now {
    color: #fff;
    font-weight: 400;
    font-size: 3.35vw;
    margin-top: 2.5vw;
    text-align: right;

    @media (orientation: portrait) {
      display: none;
    }

    &.time-landscape-mode {
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }
  }

  .time-portrait-mode {
    display: none;

    @media (orientation: portrait) {
      display: block;
    }
  }
`;
const SLIDE_IN_CONTENT_TIME = 1 * 1000;
const SLIDE_OUT_CONTENT_TIME = 1 * 1000;
const WeatherPage = (props) => {
    const { content, openNextSlide, settings, weatherData, venue, setCurrentSlideDuration } = props;
    const fadeInTimeout = (0, react_1.useRef)(null);
    const slideInTimeout = (0, react_1.useRef)(null);
    const displaySlideTimeout = (0, react_1.useRef)(null);
    const slideOutTimeout = (0, react_1.useRef)(null);
    const { stopAnimationsInSlide, changeSlideInterval, speed, fadeInContentTime } = settings;
    const { symbol } = weatherData.current;
    const currentWeatherIsBad = !!(symbol === 'rain' || symbol === 'snow' || symbol === 'sleet');
    const timeNow = helpers_1.Helpers.convertDateToTimezone(new Date().toISOString(), venue.timezone, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: i18n_js_1.default.currentLocale() === 'en',
    });
    const clearTimeouts = () => {
        clearTimeout(fadeInTimeout.current);
        clearTimeout(slideInTimeout.current);
        clearTimeout(displaySlideTimeout.current);
        clearTimeout(slideOutTimeout.current);
    };
    (0, react_1.useEffect)(() => () => {
        clearTimeouts();
    }, []);
    const handleNextSlide = () => {
        // console.log( "open next slide" );
        if (!settings.stopSlideShow && !props.isDsInteractive) {
            openNextSlide();
        }
    };
    const slideOutContent = () => {
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('day-weather')[0].classList.add('animate__fadeOut');
            document.getElementsByClassName('day-1')[0].classList.add('animate__fadeOutDown', 'exit-4');
            document.getElementsByClassName('day-2')[0].classList.add('animate__fadeOutDown', 'exit-3');
            document.getElementsByClassName('day-3')[0].classList.add('animate__fadeOutDown', 'exit-2');
            document.getElementsByClassName('day-4')[0].classList.add('animate__fadeOutDown', 'exit-1');
            document.getElementsByClassName('time-landscape-mode')[0].classList.add('animate__fadeOut');
        }
        slideOutTimeout.current = setTimeout(() => {
            handleNextSlide();
        }, SLIDE_OUT_CONTENT_TIME / speed);
    };
    const displayContent = () => {
        displaySlideTimeout.current = setTimeout(() => {
            slideOutContent();
        }, changeSlideInterval);
    };
    const slideInContent = () => {
        document.getElementsByClassName('day-weather')[0].classList.remove('hidden');
        document.getElementsByClassName('lower-content')[0].classList.remove('hidden');
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('day-weather')[0].classList.add('animate__fadeIn');
            document.getElementsByClassName('day-1')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('day-2')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('day-3')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('day-4')[0].classList.add('animate__fadeInUp');
        }
        slideInTimeout.current = setTimeout(() => {
            displayContent();
        }, SLIDE_IN_CONTENT_TIME / speed);
    };
    (0, react_1.useEffect)(() => {
        clearTimeouts();
        if (!props.isDsInteractive) {
            i18n_js_1.default.locale = content.languageSelected;
            setCurrentSlideDuration(fadeInContentTime + SLIDE_IN_CONTENT_TIME / speed + changeSlideInterval + SLIDE_OUT_CONTENT_TIME / speed);
        }
        fadeInTimeout.current = setTimeout(() => {
            slideInContent();
        }, fadeInContentTime);
    }, [content]);
    const weatherClass = (0, weatherHelpers_1.getWeatherClass)(weatherData, venue);
    // without this class animations do not trigger
    const mainAnimationClass = stopAnimationsInSlide ? '' : 'animate__animated';
    const weatherSummary = i18n_js_1.default.t(`weather.${symbol}`);
    return (react_1.default.createElement(WeatherPageContainer, { className: `${weatherClass} animate__animated animate__fadeIn`, fadeInContentTime: fadeInContentTime / 1000, slideInTime: SLIDE_IN_CONTENT_TIME / speed / 1000 },
        react_1.default.createElement(material_1.Box, { className: `day-weather ${mainAnimationClass} hidden` },
            react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.Typography, { className: "now" },
                    " ",
                    i18n_js_1.default.t('dictionary.weather.now').toUpperCase(),
                    " "),
                react_1.default.createElement(material_1.Box, { className: "weather-location" },
                    react_1.default.createElement(material_1.Box, { display: "flex", alignItems: "flex-end" },
                        react_1.default.createElement(material_1.Typography, { className: "temperature" },
                            " ",
                            weatherData.current.temperature,
                            "\u00B0 "),
                        react_1.default.createElement(material_1.Typography, { className: "summary" },
                            " ",
                            weatherSummary,
                            " ")),
                    react_1.default.createElement(material_1.Box, { className: "time-now time-portrait-mode" },
                        " ",
                        timeNow,
                        " "))),
            react_1.default.createElement(HourlyForecastLinear_1.default, { forecast: weatherData.hourlyForecast, asSlide: false })),
        react_1.default.createElement(material_1.Box, { className: ` ${mainAnimationClass} lower-content hidden` },
            react_1.default.createElement(DayForecastLinear_1.default, { forecast: weatherData.forecast, currentWeatherIsBad: currentWeatherIsBad, settings: settings }),
            react_1.default.createElement(material_1.Box, { className: `time-now time-landscape-mode ${mainAnimationClass} animate__fadeIn` },
                " ",
                timeNow,
                " "))));
};
const mapStoreToProps = store => ({
    weatherData: store.getValue('weather'),
    venue: store.getValue('venue'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(WeatherPage);
